module.exports = __webpack_public_path__ + "static/media/tokeneconomy.4134f38d.png";